// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"91":"48ce25e4f600c040","188":"484ae5d64285a76c","374":"8e64607611cac180","409":"f5f345bfafc32354"}[chunkId] + ".js";
};